import React, { useMemo, useEffect } from 'react'
import { Switch, Route } from 'react-router-dom'
import Media from 'react-media'

import config from './config'
import routes from './routes'
import { SIZES } from './styles/theme'
import EntrancePages from './containers/EntrancePages'
import PrivateRoute from './containers/PrivateRoute'

import RegistrationPage from './pages/registration/RegisterFormPage'
import PostRegistrationPage from './pages/registration/PostRegisterPage'
import SetPasswordFormPage from './pages/registration/SetPasswordFormPage'
import ActiveUserCountPage from './pages/ActiveUserCountPage'
import UserSessionPage from './pages/UserSessionPage'
import { AdminLiveQuestionPage } from './pages/AdminLiveQuestionPage'
import CountdownPage from './pages/CountdownPage'
import LandingPage from './pages/LandingPage/LandingPage'

import AuditoriumPage from './webOnlyPages/AuditoriumPage'
import NetworkingLoungePage from './webOnlyPages/NetworkingLoungePage'
import ExhibitionPage from './webOnlyPages/ExhibitionPage'
import BoothPage from './webOnlyPages/BoothPage'
import { DesktopOnDemand } from './webOnlyPages/DesktopOnDemand'
import { LobbyPage } from './webOnlyPages/LobbyPage'

import MobileExpoBooth from './mobileOnlyPages/MobileExpo/MobileExpoBooth.js'
import MobileExpoDirectory from './mobileOnlyPages/MobileExpo/MobileExpoDirectory.js'
import MobileAuditorium from './mobileOnlyPages/MobileAuditorium/index.js'
import MobileLobby from './mobileOnlyPages/MobileLobby/index.js'
import MobileMenu from './mobileOnlyPages/MobileMenu/index.js'
import MobileNetworking from './mobileOnlyPages/MobileNetworking/index.js'
import MobileNotifications from './mobileOnlyPages/MobileNotifications/index.js'
import { MobileOnDemand } from './mobileOnlyPages/MobileOnDemand/'
import { MobileGamification } from './mobileOnlyPages/MobileGamification'
import { NotFoundPage } from './pages/NotFoundPage'
import { SingleSignOnHandler } from './containers/SingleSignOnHandler'

declare global {
  interface Window {
    chaport: any
  }
}

function App() {
  useEffect(() => {
    document.title = config.eventName
  }, [])

  useEffect(() => {
    window.chaport.q('hideLauncher')
  }, [])

  return useMemo(() => {
    return (
      <div id="innerBody">
        <Switch>
          <Route exact path={routes.landing} component={LandingPage} />
          <Route exact path={routes.root} component={CountdownPage} />
          <Route exact path={routes.registration} component={RegistrationPage} />
          <Route exact path={routes.postRegister} component={PostRegistrationPage} />
          <Route exact path={routes.resetPassword} component={SetPasswordFormPage} />
          <PrivateRoute blockedRoles={['participant', 'exhibitor', 'speaker']} exact path="/realtime" component={ActiveUserCountPage} />
          <PrivateRoute blockedRoles={['participant', 'exhibitor', 'speaker']} exact path="/sessions" component={UserSessionPage} />
          <PrivateRoute blockedRoles={['participant', 'exhibitor', 'speaker']} exact path="/live-questions/:hallNumber" component={AdminLiveQuestionPage} />
          <Route exact path={routes.login} component={EntrancePages} />
          <Route exact path={routes.sso} component={SingleSignOnHandler} />
        </Switch>

        <Media query={`(max-width: ${SIZES.mobileBreakpoint})`}>
          {(matches) =>
            matches ? (
              // MOBILE ROUTES
              <Switch>
                <PrivateRoute path={routes.lobby} component={MobileLobby} mobileNav />

                {/* Auditorium */}
                <PrivateRoute
                  mobileNav
                  path={routes.auditorium1}
                  // component={(props) => <MobileAuditorium {...props} hallNumber={1} liveUrl="https://vimeo.com/event/1091833/embed/c434cf4535" />}
                  component={(props) => <MobileAuditorium {...props} hallNumber={1} liveUrl="https://player.vimeo.com/video/638947997" />}
                />

                {/* <PrivateRoute path={routes.networking} component={MobileNetworking} mobileNav /> */}
                <PrivateRoute path="/exhibition-hall/:hallId" component={MobileExpoDirectory} mobileNav />
                <PrivateRoute path="/booths/:boothId" component={MobileExpoBooth} mobileNav />
                <PrivateRoute path="/menu" component={MobileMenu} mobileNav />
                <PrivateRoute path={routes.notifications} component={MobileNotifications} mobileNav />
                <PrivateRoute path={routes.onDemand} component={MobileOnDemand} mobileNav />
                <PrivateRoute path={routes.lucky} component={MobileGamification} mobileNav />
              </Switch>
            ) : (
              // DESKTOP ROUTES
              <Switch>
                <PrivateRoute path={routes.lobby} component={LobbyPage} fixedNav />
                {/* <PrivateRoute path={routes.networking} component={NetworkingLoungePage} fixedNav /> */}

                {/* Auditorium */}
                <PrivateRoute
                  fixedNav
                  path={routes.auditorium1}
                  // component={(props) => <AuditoriumPage {...props} hallNumber={1} liveUrl="https://vimeo.com/event/1091833/embed/c434cf4535" />}
                  component={(props) => <AuditoriumPage {...props} hallNumber={1} liveUrl="https://player.vimeo.com/video/638947997" />}
                />

                <PrivateRoute path="/exhibition-hall/:hallId" component={ExhibitionPage} fixedNav />
                <PrivateRoute path="/booths/:boothId" component={BoothPage} fixedNav />
                <PrivateRoute path={routes.onDemand} component={DesktopOnDemand} fixedNav />
              </Switch>
            )
          }
        </Media>

        {/* <Switch>
          <Route component={NotFoundPage} />
        </Switch> */}
      </div>
    )
  }, [])
}

export default App
